import { EpiContent } from '@api/types';
import { ContentArea, useMultilevelMenuContext } from '@components';
import { useAppDispatch } from '@hooks';
import { Box, ClickAwayListener } from '@mui/material';
import { setModalState } from '@store/modal/modal.slice';
import React from 'react';

// TYPES
//-------
export type MegaMenuProps = {
  id?: string;
  header?: EpiContent;
  children?: React.ReactNode;
  disableEditPanel?: boolean;
};

// COMPONENTS
//------------
export const MegaMenu = ({ children, id, header }: MegaMenuProps) => {
  const dispatch = useAppDispatch();

  const setIsVisible = (newValue: boolean) =>
    dispatch(
      setModalState({ id: id || 'default-mega-menu', isVisible: newValue, type: 'submenu' })
    );
  const { megaMenuBlockRef } = useMultilevelMenuContext();
  return (
    <ClickAwayListener onClickAway={() => setIsVisible(false)}>
      <Box className='mega-menu-block' ref={megaMenuBlockRef}>
        <Box onClick={() => setIsVisible(true)}>
          <ContentArea content={header} />
        </Box>
        {children}
      </Box>
    </ClickAwayListener>
  );
};
